import { createAction } from "@reduxjs/toolkit";
import { action } from "../actions";
export const joinConferenceRequest = createAction(action("JOIN_CONFERENCE_REQUEST"));
export const joinConferenceSuccess = createAction(action("JOIN_CONFERENCE_SUCCESS"));
export const joinConferenceFailure = createAction(action("JOIN_CONFERENCE_FAILURE"));
export const getConferenceStateRequest = createAction(action("GET_CONFERENCE_STATE_REQUEST"));
export const getConferenceStateSuccess = createAction(action("GET_CONFERENCE_STATE_SUCCESS"));
export const getConferenceStateFailure = createAction(action("GET_CONFERENCE_STATE_FAILURE"));
export const conferenceEvent = createAction(action("CONFERENCE_EVENT"));
export const leaveConferenceRequest = createAction(action("LEAVE_CONFERENCE_REQUEST"));
export const leaveConferenceSuccess = createAction(action("LEAVE_CONFERENCE_SUCCESS"));
export const leaveConferenceFailure = createAction(action("LEAVE_CONFERENCE_FAILURE"));
export const endConferenceRequest = createAction(action("END_CONFERENCE_REQUEST"));
export const endConferenceSuccess = createAction(action("END_CONFERENCE_SUCCESS"));
export const endConferenceFailure = createAction(action("END_CONFERENCE_FAILURE"));
export const conferenceHasEnded = createAction(action("CONFERENCE_HAS_ENDED"));
export const conferenceHasFailed = createAction(action("CONFERENCE_HAS_FAILED"));
export const conferenceHoldEvent = createAction(action("CONFERENCE_HOLD_EVENT"));
export const trackMuteUpdateEvent = createAction(action("TRACK_MUTE_UPDATE_EVENT"));
//# sourceMappingURL=actions.js.map